var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Connection, PublicKey } from '@solana/web3.js';
import { decodeProfilePictureAccount, getParsedMultipleAccountsInfo, getProfilePicturePDA } from './utils';
import { Metaplex } from '@metaplex-foundation/js';
var BATCH_INTERVAL = 200;
var BATCH_SIZE = 50;
var batchedRequests = new Map();
var timeouts = new Map();
function rejectRequest(request, error) {
    var e_1, _a;
    request.resolved = true;
    try {
        for (var _b = __values(request.resolvers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var resolver = _c.value;
            resolver.reject(error);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function filterResolved(requests) {
    return requests.filter(function (request) { return !request.resolved; });
}
function processRequests(endpoint, commitment) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return __awaiter(this, void 0, void 0, function () {
        var requests, _q, _r, _s, pubkey, resolvers, connection, requests_1, requests_1_1, request, _t, e_2_1, profilePictureAccounts, i, tokenAccounts, i, metaplex_1, metadatas, i, requests_2, requests_2_1, request, _u, _v, resolver, err_1, requests_3, requests_3_1, request;
        var e_3, _w, e_2, _x, e_4, _y, e_5, _z, e_6, _0;
        var _this = this;
        return __generator(this, function (_1) {
            switch (_1.label) {
                case 0:
                    if (!batchedRequests.has(endpoint)) {
                        return [2 /*return*/];
                    }
                    requests = [];
                    try {
                        for (_q = __values(batchedRequests.get(endpoint)), _r = _q.next(); !_r.done; _r = _q.next()) {
                            _s = __read(_r.value, 2), pubkey = _s[0], resolvers = _s[1];
                            requests.push({ publicKey: new PublicKey(pubkey), resolvers: resolvers, resolved: false });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_r && !_r.done && (_w = _q.return)) _w.call(_q);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    timeouts.delete(endpoint);
                    batchedRequests.delete(endpoint);
                    _1.label = 1;
                case 1:
                    _1.trys.push([1, 14, , 15]);
                    connection = new Connection(endpoint, commitment);
                    _1.label = 2;
                case 2:
                    _1.trys.push([2, 7, 8, 9]);
                    requests_1 = __values(requests), requests_1_1 = requests_1.next();
                    _1.label = 3;
                case 3:
                    if (!!requests_1_1.done) return [3 /*break*/, 6];
                    request = requests_1_1.value;
                    _t = request;
                    return [4 /*yield*/, getProfilePicturePDA(new PublicKey(request.publicKey))];
                case 4:
                    _t.pfpAccountPublicKey = _1.sent();
                    _1.label = 5;
                case 5:
                    requests_1_1 = requests_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_2_1 = _1.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (requests_1_1 && !requests_1_1.done && (_x = requests_1.return)) _x.call(requests_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 9: return [4 /*yield*/, connection.getMultipleAccountsInfo(requests.map(function (request) { return request.pfpAccountPublicKey; }))];
                case 10:
                    profilePictureAccounts = _1.sent();
                    for (i = 0; i < profilePictureAccounts.length; i++) {
                        if (profilePictureAccounts[i]) {
                            requests[i].profilePictureAccount = profilePictureAccounts[i];
                            try {
                                requests[i].profilePictureData = decodeProfilePictureAccount(profilePictureAccounts[i]);
                            }
                            catch (err) {
                                rejectRequest(requests[i], new Error('Failed to decode PFP PDA'));
                            }
                        }
                        else {
                            rejectRequest(requests[i], new Error('PFP PDA is empty'));
                        }
                    }
                    requests = filterResolved(requests);
                    return [4 /*yield*/, getParsedMultipleAccountsInfo(connection, requests.map(function (request) { return request.profilePictureData.nftTokenAccount; }))];
                case 11:
                    tokenAccounts = _1.sent();
                    for (i = 0; i < tokenAccounts.length; i++) {
                        if (!tokenAccounts[i]) {
                            rejectRequest(requests[i], new Error('No PFP token account'));
                            continue;
                        }
                        if (((_e = (_d = (_c = (_b = (_a = tokenAccounts[i]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.parsed) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.tokenAmount) === null || _e === void 0 ? void 0 : _e.uiAmount) < 1) {
                            rejectRequest(requests[i], new Error('PFP NFT token account is empty'));
                            continue;
                        }
                        if (((_j = (_h = (_g = (_f = tokenAccounts[i]) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.parsed) === null || _h === void 0 ? void 0 : _h.info) === null || _j === void 0 ? void 0 : _j.owner) !== requests[i].publicKey.toString()) {
                            rejectRequest(requests[i], new Error('Invalid PFP token account owner'));
                            continue;
                        }
                        if (((_o = (_m = (_l = (_k = tokenAccounts[i]) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.parsed) === null || _m === void 0 ? void 0 : _m.info) === null || _o === void 0 ? void 0 : _o.mint) !== requests[i].profilePictureData.nftMint.toString()) {
                            rejectRequest(requests[i], new Error('Invalid token account mint'));
                            continue;
                        }
                        requests[i].tokenAccount = tokenAccounts[i];
                    }
                    requests = filterResolved(requests);
                    metaplex_1 = Metaplex.make(connection);
                    return [4 /*yield*/, metaplex_1.nfts().findAllByMintList({ mints: requests.map(function (request) { return request.profilePictureData.nftMint; }) }).run()];
                case 12:
                    metadatas = _1.sent();
                    for (i = 0; i < metadatas.length; i++) {
                        if ((_p = metadatas[i]) === null || _p === void 0 ? void 0 : _p.uri) {
                            requests[i].metadata = metadatas[i];
                        }
                        else {
                            rejectRequest(requests[i], new Error('No PFP metadata URL'));
                        }
                    }
                    requests = filterResolved(requests);
                    return [4 /*yield*/, Promise.all(requests.map(function (request) { return __awaiter(_this, void 0, void 0, function () {
                            var nft, err_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, metaplex_1.nfts().load({ metadata: request.metadata }).run()];
                                    case 1:
                                        nft = _a.sent();
                                        if (!(nft === null || nft === void 0 ? void 0 : nft.jsonLoaded) || !(nft === null || nft === void 0 ? void 0 : nft.json)) {
                                            throw new Error('No PFP JSON metadata');
                                        }
                                        request.metadata = nft;
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_2 = _a.sent();
                                        rejectRequest(request, err_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 13:
                    _1.sent();
                    requests = filterResolved(requests);
                    try {
                        for (requests_2 = __values(requests), requests_2_1 = requests_2.next(); !requests_2_1.done; requests_2_1 = requests_2.next()) {
                            request = requests_2_1.value;
                            request.resolved = true;
                            try {
                                for (_u = (e_5 = void 0, __values(request.resolvers)), _v = _u.next(); !_v.done; _v = _u.next()) {
                                    resolver = _v.value;
                                    resolver.resolve({
                                        pfpAccountPublicKey: request.pfpAccountPublicKey,
                                        profilePictureAccount: request.profilePictureAccount,
                                        profilePictureData: request.profilePictureData,
                                        tokenAccount: request.tokenAccount,
                                        metadata: request.metadata
                                    });
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_v && !_v.done && (_z = _u.return)) _z.call(_u);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (requests_2_1 && !requests_2_1.done && (_y = requests_2.return)) _y.call(requests_2);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    return [3 /*break*/, 15];
                case 14:
                    err_1 = _1.sent();
                    try {
                        for (requests_3 = __values(requests), requests_3_1 = requests_3.next(); !requests_3_1.done; requests_3_1 = requests_3.next()) {
                            request = requests_3_1.value;
                            rejectRequest(request, err_1);
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (requests_3_1 && !requests_3_1.done && (_0 = requests_3.return)) _0.call(requests_3);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    });
}
export function pushRequest(connection, publicKey, resolve, reject) {
    var endpoint = connection.rpcEndpoint;
    var pubkey = publicKey.toString();
    if (!batchedRequests.has(endpoint)) {
        batchedRequests.set(endpoint, new Map());
    }
    if (!batchedRequests.get(endpoint).has(pubkey)) {
        batchedRequests.get(endpoint).set(pubkey, []);
    }
    batchedRequests.get(endpoint).get(pubkey).push({ resolve: resolve, reject: reject });
    if (batchedRequests.get(endpoint).size >= BATCH_SIZE && timeouts.has(endpoint)) {
        processRequests(endpoint, connection.commitment || 'processed');
    }
    var timeout = setTimeout(function () { return processRequests(endpoint, connection.commitment || 'processed'); }, BATCH_INTERVAL);
    timeouts.set(endpoint, timeout);
}
